import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientNotificationHandlerService, CommonUtilityLib, StorageUtilityLib, USER_SESSION_TOKEN, UserSession, anyUserProfile } from '@thehubz/client/core';
import { User, UsersApiService } from '@thehubz/client/data-access-api';

@Component({
  selector: 'thehubz-user-profile-new',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  isOtherUser = false;
  userData!: User;
  userId?: string;

  AnyUserProfile = anyUserProfile;

  constructor(
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private userService: UsersApiService,
    private storageUtility: StorageUtilityLib,
    private commonUtilityLib: CommonUtilityLib,
    private route: ActivatedRoute,
    private clientNotificationHandlerService: ClientNotificationHandlerService,
  ) {}

  ngOnInit(): void {
    this.getUserId();
  }

  getUserId() {
    const userSession = this.storageUtility.getLocalStorage<UserSession>(this.userSessionToken);
    this.route.queryParamMap.subscribe((paramsMap: any) => {
      if (paramsMap.params && paramsMap.params.userId && paramsMap.params.userId !== userSession?.userData?._id) {
        this.userId = paramsMap.params.userId;
        this.isOtherUser = true;
      } else {
        this.isOtherUser = false;
        this.userId = userSession?.userData?._id;
      }
      this.getUser();
    });
  }

  getUser() {
    if (this.userId) {
      this.userService.usersControllerFindOne(this.userId, true).subscribe({
        next: (response) => {
          if (response) {
            this.userData = response;
            this.commonUtilityLib.emitNewHeaderline(this.userData.firstName + ' ' + this.userData.lastName);
          }
        },
        error: (err) => {
          this.clientNotificationHandlerService.errorNotification(err);
        },
      });
    }
  }
}
